import React from 'react';

/* types */
import { Box } from '../box';
import { IChipProps } from '../types';

/* styled */
import { StyledChip } from './styled';
import { IconArrowDropDown, IconCancelCircle } from '@mzc-cloudplex/icons';
import { Badge, Divider, Typography } from '@mui/material';

export const Chip = React.forwardRef<HTMLDivElement, IChipProps>(
  (
    {
      type,
      label,
      title,
      labelLength,
      clickable,
      radius,
      readOnly,
      variant,
      color,
      size,
      icon,
      avatar,
      onDelete,
      onClick,
      isOpen,
      ...restProps
    },
    ref
  ) => {
    return (
      <>
        <StyledChip
          {...restProps}
          className={isOpen ? 'active' : ''}
          type={type}
          variant={variant}
          radius={radius}
          color={color}
          size={size}
          icon={icon}
          avatar={avatar}
          onDelete={onDelete}
          onClick={onClick}
          readOnly={readOnly}
          deleteIcon={<IconCancelCircle size={12} htmlColor={'#939bb7'} />}
          label={
            <Box sx={{ display: `inline-flex`, alignItems: `center` }}>
              {title && (
                <Typography
                  variant={'body2'}
                  color={label ? '#2763ea' : '#3c3d4f'}
                  component={'small'}
                  sx={{ marginRight: `12px` }}
                >
                  {title}
                </Typography>
              )}
              {label && <span>{label}</span>}
              {labelLength && (
                <>
                  <Badge
                    badgeContent={`+ ${labelLength}`}
                    color='primary'
                    sx={{
                      '.MuiBadge-badge ': {
                        position: `static`,
                        transform: `none`,
                        marginLeft: `8px`,
                        fontSize: `11px`,
                        fontWeight: `bold`,
                        lineHeight: `1.45`
                      }
                    }}
                  />
                </>
              )}
              {clickable && (
                <>
                  <Box
                    className={'iconWrap'}
                    sx={{
                      display: `flex`,
                      alignItems: `center`,
                      justifyContent: `center`,
                      backgroundColor: isOpen ? `#3c3d4f14` : ``
                    }}
                    width={`20px`}
                    height={`20px`}
                    radius={20}
                  >
                    <IconArrowDropDown size={8} htmlColor={`#6f6f83 `} />
                  </Box>
                  {onDelete && (
                    <Divider
                      sx={{
                        width: `1px`,
                        height: `20px`,
                        backgroundColor: `#d0d0df`,
                        marginLeft: `8px`,
                        marginRight: `12px`
                      }}
                    />
                  )}
                </>
              )}
            </Box>
          }
        />
      </>
    );
  }
);
